import { render, staticRenderFns } from "./cusSerListOld.vue?vue&type=template&id=8c53fd2e&scoped=true"
import script from "./cusSerListOld.vue?vue&type=script&lang=js"
export * from "./cusSerListOld.vue?vue&type=script&lang=js"
import style0 from "./cusSerListOld.vue?vue&type=style&index=0&id=8c53fd2e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c53fd2e",
  null
  
)

export default component.exports